<div>
  @if (quotesLoading()) {
    <div class="flex justify-center p-4">
      <mat-spinner></mat-spinner>
    </div>
  } @else if (quotesError()) {
    <div class="flex justify-center p-4">
      <p class="text-red-500">{{ errorText }}</p>
    </div>
  } @else {
    <div class="overflow-x-auto">
      <table
        mat-table
        [dataSource]="dataSource"
        [matSortActive]="currentSort.active"
        [matSortDirection]="currentSort.direction"
        matSort
        (matSortChange)="sortData($event)"
        class="w-full"
      >
        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              (change)="$event ? toggleAllRows() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()"
              [aria-label]="checkboxLabel()"
            >
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)"
              [aria-label]="checkboxLabel(row)"
            >
            </mat-checkbox>
          </td>
        </ng-container>

        <!-- Quote Column -->
        <ng-container matColumnDef="quoteId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Quote
          </th>
          <td mat-cell *matCellDef="let quote" class="border-b p-4">
            {{ quote.quoteId }}
          </td>
        </ng-container>

        <!-- Description Column -->
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Description
          </th>
          <td mat-cell *matCellDef="let quote" class="border-b p-4">
            {{ quote.description }}
          </td>
        </ng-container>

        <!-- CA# Column -->
        <ng-container matColumnDef="caNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            CA#
          </th>
          <td mat-cell *matCellDef="let quote" class="border-b p-4">
            {{ quote.caNumber }}
          </td>
        </ng-container>

        <!-- Quantity Column -->
        <ng-container matColumnDef="quantity">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Quantity
          </th>
          <td mat-cell *matCellDef="let quote" class="border-b p-4">
            {{ quote.quantity }}
          </td>
        </ng-container>

        <!-- Created Column -->
        <ng-container matColumnDef="dateCreated">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Created Date
          </th>
          <td mat-cell *matCellDef="let quote" class="border-b p-4">
            {{ quote.dateCreated | date: CONFIG.date.createdDateFormat }}
          </td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Status
          </th>
          <td mat-cell *matCellDef="let quote" class="border-b p-4">
            {{ quote.status?.value }}
          </td>
        </ng-container>

        <!-- Client Column -->
        <ng-container matColumnDef="client">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Client
          </th>
          <td mat-cell *matCellDef="let quote" class="border-b p-4">
            {{ quote.client }}
          </td>
        </ng-container>

        <!-- Assignee Column -->
        <ng-container matColumnDef="assignee">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Assignee
          </th>
          <td mat-cell *matCellDef="let quote" class="border-b p-4">
            {{ quote.assignee }}
          </td>
        </ng-container>

        <!-- Last Edited Column -->
        <ng-container matColumnDef="dateUpdated">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Last Edited
          </th>
          <td mat-cell *matCellDef="let quote" class="border-b p-4">
            {{ quote.lastEdited | date: CONFIG.date.createdDateFormat }}
          </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="border-b p-4 text-right w-24"></th>
          <td mat-cell *matCellDef="let quote" class="border-b p-4 text-right">
            <div class="invisible group-hover:visible flex items-center justify-end gap-2">
              <button
                mat-icon-button
                matTooltip="Unarchive Quote"
                (click)="unarchiveQuote(quote); $event.stopPropagation()"
                class="text-gray-700"
              >
                <mat-icon>unarchive</mat-icon>
              </button>
              <button
                mat-icon-button
                matTooltip="Edit Quote"
                (click)="editQuote(quote); $event.stopPropagation()"
                class="text-gray-700"
              >
                <mat-icon>edit</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="viewQuoteDetails(row)"
          class="hover:bg-gray-100 cursor-pointer quote-row group"
        ></tr>
      </table>
      <div
        *ngIf="!quotesLoading() && !quotesError() && dataSource.data.length === 0"
        class="text-center text-gray-500 py-8"
      >
        There are no records available.
      </div>
    </div>

    <ng-container *ngIf="dataSource.data.length !== 0">
      <ciwc-pagination
        [currentPage]="pageIndex"
        [pageSize]="pageSize"
        [totalItems]="quotesLength()"
        [pageSizeOptions]="pageSizeOptions"
        (pageChange)="handlePageEvent($event)"
      ></ciwc-pagination>

      <!-- Hidden paginator for functionality -->
      <div class="hidden">
        <mat-paginator
          #paginator
          [length]="quotesLength()"
          [pageSize]="pageSize"
          [pageSizeOptions]="pageSizeOptions"
          (page)="handlePageEvent($event)"
          aria-label="Select page"
        >
        </mat-paginator>
      </div>
    </ng-container>

    <div class="flex justify-between">
      <div>
        <ng-container *ngIf="hasSelection">
          <button
            mat-flat-button
            color="primary"
            (click)="exportQuotesBundle()"
            [disabled]="exportQuotesBundleLoading()"
            class="mr-4 !bg-green-600 !hover:bg-green-700 !text-white font-semibold shadow-md flex items-center gap-2"
          >
            <ng-container *ngIf="!exportQuotesBundleLoading(); else loadingSpinner">
              Export Quotes
            </ng-container>
            <ng-template #loadingSpinner>
              <div class="flex gap-2">
                <mat-spinner diameter="20"></mat-spinner>
                <span>Exporting...</span>
              </div>
            </ng-template>
          </button>
        </ng-container>
      </div>
      <div *ngIf="exportQuotesBundleError()" class="text-red-600 ml-2 flex items-center">
        {{ exportQuotesBundleError() }}
      </div>
    </div>
  }
</div>
